import { render, staticRenderFns } from "./Dev.vue?vue&type=template&id=c8ffee9c&scoped=true&"
import script from "./Dev.vue?vue&type=script&lang=js&"
export * from "./Dev.vue?vue&type=script&lang=js&"
import style0 from "./Dev.vue?vue&type=style&index=0&id=c8ffee9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ffee9c",
  null
  
)

export default component.exports